import { Controller } from "@hotwired/stimulus"
import { attachOverflowCues } from "../lib/overflow_cues"

// Edge-fade overflow cues (#5154) for a horizontal scroller that has no other
// controller — e.g. the shared stat-card row (shared/_stat_cards), whose
// clipped side must fade per the menu-overflow standard (extended to
// stat-card rows by owner ruling 2026-08-26). Attach on the SCROLLER; the
// wrapping shell anchors the `.gl-table-edge-cue` spans the toggled
// `has-overflow-left/right` classes drive. Tab strips use
// `settings_tabs_controller` instead (same cues, plus active-tab centering).
export default class extends Controller {
  connect() {
    this.detachOverflowCues = attachOverflowCues(this.element)
  }

  disconnect() {
    this.detachOverflowCues?.()
  }
}
